import * as launchDarklyClient from 'launchdarkly-js-client-sdk';
import type { LDClient as LDClientInterface } from 'launchdarkly-js-client-sdk';
import { createContext, PropsWithChildren } from 'react';
import { LD_CLIENT_ID } from '~/utils/constants';
import { store } from '~/utils/store';

export const LDContext = createContext({} as LDClientInterface);
export const LD_KEY = 'flex'; // https://docs.launchdarkly.com/home/users/anonymous-users/?q=anonymous

// stub -Starting with version 3.x.x and abobe LD expects context to be passed instead of user. The context can be changed at any time using identify().
const context = {
  key: store.get('USER_ID') ? String(store.get('USER_ID')) : LD_KEY,
  kind: 'user',
  custom: {
    funnel: store.get('ACTIVE_FUNNEL_ID') || '',
    utilityId: store.get('UTILITY_SELECTION')?.id || '',
  },
};

export const LDClient = launchDarklyClient.initialize(LD_CLIENT_ID, context, {
  bootstrap: 'localStorage',
});

export const LDProvider = ({
  children,
  client = LDClient,
}: PropsWithChildren<{ client: LDClientInterface }>) => {
  return <LDContext.Provider value={client}>{children}</LDContext.Provider>;
};
